import { useState } from 'react';
import toast from 'react-hot-toast';

import { IconClose } from '../../../common/icons';
import { useModalDialog } from '../../../common/hooks/use-modal-dialog';
import { useCreateMedicalEvent } from '../../medical/contexts/medical';

import '../../../common/styles/catalog.css';
import './styles/form.css';

const today = () => new Date().toLocaleDateString('en-CA');

// Formulario de aborto: registra un evento médico `abortion` sobre la RECEPTORA
// (admin-medical-events.md). Con pregnancy_id, la preñez transiciona a `lost`.
export default function AbortForm({ pregnancyId, recipientId, recipientLabel, onClose, onSaved }) {
    const { mutateAsync, isPending } = useCreateMedicalEvent();
    const cardRef = useModalDialog(onClose);
    const [date, setDate] = useState(today());
    const [remarks, setRemarks] = useState('');

    const submit = async (ev) => {
        ev.preventDefault();
        if (!date) { toast.error('Indicá la fecha'); return; }
        if (!recipientId) { toast.error('Falta la receptora del evento'); return; }
        if (!pregnancyId) { toast.error('Falta la preñez a cerrar'); return; }
        try {
            await mutateAsync({
                recipient_id: recipientId,
                pregnancy_id: pregnancyId,
                type: 'abortion',
                date,
                ...(remarks.trim() ? { remarks: remarks.trim() } : {}),
            });
            toast.success('Aborto registrado');
            onSaved?.();
            onClose();
        } catch (er) {
            if (er?.status !== 403) toast.error(er?.message || 'No se pudo registrar el aborto');
        }
    };

    return (
        <div className="birth-modal" role="dialog" aria-modal="true" aria-label="Registrar aborto">
            <div className="birth-modal__overlay" onClick={onClose} aria-hidden="true" />
            <form className="birth-modal__card birth-modal__card--narrow" ref={cardRef} onSubmit={submit}>
                <header className="birth-modal__head">
                    <div>
                        <h2 className="birth-modal__title">Registrar aborto</h2>
                        {recipientLabel && <span className="birth-modal__sub">Receptora {recipientLabel}</span>}
                    </div>
                    <button type="button" className="birth-modal__close" onClick={onClose} aria-label="Cerrar"><IconClose /></button>
                </header>

                <p className="birth-modal__warn">El aborto cierra la preñez (pasa a <strong>perdida</strong>) y queda registrado como evento médico de la receptora.</p>

                <div className="birth-modal__grid">
                    <label className="cat-form__field">
                        <span className="cat-form__label">Fecha</span>
                        <input type="date" value={date} max={today()} onChange={(e) => setDate(e.target.value)} disabled={isPending} />
                    </label>
                    <label className="cat-form__field birth-modal__field--full">
                        <span className="cat-form__label">Notas</span>
                        <textarea value={remarks} rows={2} onChange={(e) => setRemarks(e.target.value)} disabled={isPending} placeholder="Causa, observaciones (opcional)" />
                    </label>
                </div>

                <footer className="birth-modal__actions">
                    <button type="button" className="birth-modal__cancel" onClick={onClose} disabled={isPending}>Cancelar</button>
                    <button type="submit" className="birth-modal__danger" disabled={isPending}>{isPending ? 'Registrando…' : 'Registrar aborto'}</button>
                </footer>
            </form>
        </div>
    );
}
